import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useCertificationHolder,
  useFind: useCertificationHolders,
  useCreate: useCertificationHolderCreation,
  useUpdate: useCertificationHolderUpdate,
  useDelete: useCertificationHolderDeletion,
} = getCRUDHooks<{ id: number; name: string; logo?: string | null }>({
  entityName: 'certificationHolders',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.certificationHolders,
});

export {
  useCertificationHolder,
  useCertificationHolders,
  useCertificationHolderCreation,
  useCertificationHolderUpdate,
  useCertificationHolderDeletion,
};
